import { render, staticRenderFns } from "./module_tab.vue?vue&type=template&id=b908d97c"
import script from "./module_tab.vue?vue&type=script&lang=js"
export * from "./module_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports